import { getAppEnvironment } from '@/environments'
import useEpiFetch from '@base/composables/useEpiFetch'

const useApi = async <T = any>(url: string, options: any = {}, versionOverride?: string) => {
  const environment = getAppEnvironment()

  const { data, error } = await useEpiFetch(environment, url, options, versionOverride)

  return { data: data as T, error }
}

export default useApi
